<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-8 profile">
        <!-- Without CMS -->
        <div v-if="isCmsUsed === false">
          <h2>
            Our Privacy Policy
          </h2>
          <b>1. Introduction</b><br />
          1.1 We are committed to safeguarding the privacy of our website
          visitors and service users.<br />
          1.2 This policy applies where we are acting as a data controller with
          respect to the personal data of our website visitors and service
          users; in other words, where we determine the purposes and means of
          the processing of that personal data.<br />
          1.3 We use cookies on our website. Insofar as those cookies are not
          strictly necessary for the provision of our website and services, we
          will ask you to consent to our use of cookies when you first visit our
          website.<br />
          1.4 In this policy, "we", "us" and "our" refer to Performance Bonus
          Ltd. For more information about us, see Section 12.<br />
          <br /><b>2. How we use your personal data</b><br />
          2.1 In this Section 2 we have set out:<br />
          (a) the general categories of personal data that we may process;<br />
          (b) the purposes for which we may process personal data; and<br />
          (d) the legal bases of the processing.<br />
          2.2 We may process data about your use of our website and services
          ("usage data"). The usage data may include your IP address,
          geographical location, browser type and version, operating system,
          referral source, length of visit, page views and website navigation
          paths, as well as information about the timing, frequency and pattern
          of your service use. The source of the usage data is our analytics
          tracking system. This usage data may be processed [or the purposes of
          analysing the use of the website and services. The legal basis for
          this processing is our legitimate interests, namely monitoring and
          improving our website and services.<br />
          2.3 We may process your account data ("account data"). The account
          data may include your name and email address.The source of the account
          data is that which you have disclosed. The account data may be
          processed for the purposes of operating our website, providing our
          services, ensuring the security of our website and services,
          maintaining back-ups of our databases and communicating with you. The
          legal basis for this processing is our legitimate interests, namely
          the proper administration of our website and business.<br />
          2.4 We may process your information included in your personal profile
          on our website "profile data". The profile data may include your name,
          address, telephone number, email address, gender, date of birth. The
          profile data may be processed for the purposes of enabling and
          monitoring your use of our website and services. The legal basis for
          this processing is our legitimate interests, namely the proper
          administration of our website and business.<br />
          2.5 We may process your personal data that are provided in the course
          of the use of our services ("service data"). The service data may
          include rewards awarded. The source of the service data is your
          employer. The service data may be processed for the purposes of
          operating our website, providing our services, ensuring the security
          of our website and services, maintaining back-ups of our databases and
          communicating with you] The legal basis for this processing is our
          legitimate interests, namely the proper administration of our website
          and business.<br />
          2.6 We may process information that you post for publication on our
          website or through our services ("publication data"). The publication
          data may be processed for the purposes of enabling such publication
          and administering our website and services. The legal basis for this
          processing is our legitimate interests, namely the proper
          administration of our website and business.<br />
          2.7 We may process information contained in any enquiry you submit to
          us regarding goods and/or services ("enquiry data"). The enquiry data
          may be processed for the purposes of offering, marketing and selling
          relevant goods and/or services to you. The legal basis for this
          processing is consent.<br />
          2.8 We may process information relating to our customer relationships,
          including customer contact information ("customer relationship data").
          The customer relationship data may include your name, your employer,
          your job title or role, your contact details, and information
          contained in communications between us and you or your employer. The
          source of the customer relationship data is you or your employer. The
          customer relationship data may be processed for the purposes of
          managing our relationships with customers, communicating with
          customers, keeping records of those communications and promoting our
          products and services to customers. The legal basis for this
          processing is our legitimate interests, namely the proper management
          of our customer relationships.<br />2.9 We may process information
          relating to transactions, including purchases of goods and services,
          that you enter into with us and/or through our website ("transaction
          data"). The transaction data may include your contact details, your
          card details and the transaction details. The transaction data may be
          processed for the purpose of supplying the purchased goods and
          services and keeping proper records of those transactions. The legal
          basis for this processing is the performance of a contract between you
          and us and/or taking steps, at your request, to enter into such a
          contract and our legitimate interests, namely the proper
          administration of our website and business.<br />
          2.10 We may process information that you provide to us for the purpose
          of subscribing to our email notifications and/or newsletters
          ("notification data"). The notification data may be processed for the
          purposes of sending you the relevant notifications and/or newsletters.
          The legal basis for this processing is consent. <br />
          2.11 We may process information contained in or relating to any
          communication that you send to us ("correspondence data"). The
          correspondence data may include the communication content and metadata
          associated with the communication. Our website will generate the
          metadata associated with communications made using the website contact
          forms. The correspondence data may be processed for the purposes of
          communicating with you and record-keeping. The legal basis for this
          processing is our legitimate interests, namely the proper
          administration of our website and business and communications with
          users.<br />
          2.12 We may process any of your personal data identified in this
          policy where necessary for the establishment, exercise or defence of
          legal claims, whether in court proceedings or in an administrative or
          out-of-court procedure. The legal basis for this processing is our
          legitimate interests, namely the protection and assertion of our legal
          rights, your legal rights and the legal rights of others.<br />
          2.13 We may process any of your personal data identified in this
          policy where necessary for the purposes of obtaining or maintaining
          insurance coverage, managing risks, or obtaining professional advice.
          The legal basis for this processing is our legitimate interests,
          namely the proper protection of our business against risks.<br />
          2.14 In addition to the specific purposes for which we may process
          your personal data set out in this Section 2, we may also process any
          of your personal data where such processing is necessary for
          compliance with a legal obligation to which we are subject, or in
          order to protect your vital interests or the vital interests of
          another natural person.<br />
          2.15 Please do not supply any other person's personal data to us,
          unless we prompt you to do so.<br /><br />
          <b>3. Providing your personal data to others</b><br />
          3.1 We may disclose your personal data to any member of our group of
          companies (this means our subsidiaries, our ultimate holding company
          and all its subsidiaries) insofar as reasonably necessary for the
          purposes, and on the legal bases, set out in this policy. Information
          about our group of companies can be found at performancebonus.com.<br />
          3.2 We may disclose your personal data to our insurers and/or
          professional advisers insofar as reasonably necessary for the purposes
          of obtaining or maintaining insurance coverage, managing risks,
          obtaining professional advice, or the establishment, exercise or
          defence of legal claims, whether in court proceedings or in an
          administrative or out-of-court procedure.<br />
          3.3 We may disclose your personal data to our suppliers or
          subcontractors identified at Performancebonus.com insofar as
          reasonably necessary to enable our services to be delivered to you.<br />
          3.4 Financial transactions relating to our website and services may be
          handled by our payment services providers, eg PayPal and or SagePay.
          We will share transaction data with our payment services providers
          only to the extent necessary for the purposes of processing your
          payments, refunding such payments and dealing with complaints and
          queries relating to such payments and refunds. You can find
          information about the payment services providers' privacy policies and
          practices at their respective URLs.<br />
          3.5 We may disclose your enquiry data to one or more of those selected
          third party suppliers of goods and services identified on our website
          for the purpose of enabling them to contact you so that they can
          offer, market and sell to you relevant goods and/or services. For
          example, prepaid Cards and electronic money (‘e-money’) loaded thereon
          may be issued by Contis Financial Services Ltd who is authorised by
          the Financial Conduct Authority to issue e-money (Firm Reference
          Number: 900025) and is a member of Visa. Alternatively they may be
          issued by Payment Card Solutions (UK) Limited trading as B4B Payments,
          a company registered in England and Wales (registration number
          05941947) and registered office at 21-24 Millbank, London, England,
          SW1P 4QP. Payment Card Solutions (UK) Limited is authorised and
          regulated in the UK by the Financial Conduct Authority (Firm Reference
          Number: 930619) for the issuing of e-money. Each such third party will
          act as a data controller in relation to the data that we supply to it;
          and as appropriate each such third party will supply to you a copy of
          its own privacy policy, which will govern that third party's use of
          your personal data.<br />
          3.6 In addition to the specific disclosures of personal data set out
          in this Section 3, we may disclose your personal data where such
          disclosure is necessary for compliance with a legal obligation to
          which we are subject, or in order to protect your vital interests or
          the vital interests of another natural person. We may also disclose
          your personal data where such disclosure is necessary for the
          establishment, exercise or defence of legal claims, whether in court
          proceedings or in an administrative or out-of-court procedure.
          <br /><br /><b>4. International transfers of your personal data</b
          ><br />
          4.1 In this Section 4, we provide information about the circumstances
          in which your personal data may be transferred to countries outside
          the European Economic Area (EEA).<br />
          4.2 The hosting facilities for our website are situated in USA. The
          European Commission has made an "adequacy decision" with respect to
          the data protection laws of this country. However, we have entered
          into the standard contractual clauses (Model Clauses) adopted by the
          European Commission with OrcsWeb Inc, in order to safeguard personal
          data when it is accessed from outside of the European Economic Area .
          We will take all steps reasonably necessary to ensure that your data
          is treated securely and in accordance with this policy when it is
          transferred, stored or processed in this way. Whenever fraud
          prevention agencies transfer your personal data outside of the
          European Economic Area, they impose the standard contractual clauses
          (Model Clauses) adopted by the European Commission on the recipients
          of that data in order to safeguard personal data when it is accessed
          from outside of the European Economic Area. They may also require the
          recipient to subscribe to ‘international frameworks’ intended to
          enable secure data sharing. More information about the Model Clauses
          is available here
          <a
            >http://eur-lex.europa.eu/legal-content/en/TXT/?uri=CELEX:32010D0087</a
          >.<br />
          4.3 You acknowledge that personal data that you submit for publication
          (eg on our Blog) through our website or services may be available, via
          the internet, around the world. We cannot prevent the use (or misuse)
          of such personal data by others.<br /><br />
          <b>5. Retaining and deleting personal data</b> <br />
          5.1 This Section 5 sets out our data retention policies and procedure,
          which are designed to help ensure that we comply with our legal
          obligations in relation to the retention and deletion of personal
          data.<br />We will retain your personal data for as long as you
          continue to use our services. Thereafter, we may retain your
          information for an additional period as is permitted or required under
          applicable laws. For example:<br />
          • If you hold an account with us, your personal data will be retained
          for five years after the closure of your account to comply with our
          obligations under anti-money laundering regulations;<br />
          • If you make a complaint, your personal data relating to that
          complaint will be retained for five years from the resolution of that
          complaint to defend against legal claims; and<br />
          If you make any transactions on your account, your personal data
          relating to that transaction will be retained for seven years from the
          date of the transaction to comply with taxation and accountancy
          legislation. <br /><br />
          <b>6. Amendments</b><br />
          6.1 We may update this policy from time to time by publishing a new
          version on our website.<br />
          6.2 You should check this page occasionally to ensure you are happy
          with any changes to this policy.<br />
          6.3 We may notify you of changes to this policy by email .<br /><br />
          <b>7. Your rights</b><br />
          7.1 In this Section 7, we have summarised the rights that you have
          under data protection law. Some of the rights are complex, and not all
          of the details have been included in our summaries. Accordingly, you
          should read the relevant laws and guidance from the regulatory
          authorities for a full explanation of these rights.<br />
          7.2 Your principal rights under data protection law are:<br />
          (a) the right to access;<br />
          (b) the right to rectification;<br />
          (c) the right to erasure;<br />
          (d) the right to restrict processing;<br />
          (e) the right to object to processing;<br />
          (f) the right to data portability;<br />
          (g) the right to complain to a supervisory authority; and<br />
          (h) the right to withdraw consent.<br />
          7.3 You have the right to confirmation as to whether or not we process
          your personal data and, where we do, access to the personal data,
          together with certain additional information. That additional
          information includes details of the purposes of the processing, the
          categories of personal data concerned and the recipients of the
          personal data. Providing the rights and freedoms of others are not
          affected, we will supply to you a copy of your personal data. The
          first copy will be provided free of charge, but additional copies may
          be subject to a reasonable fee. You can request your personal data by
          writing to The Data Controller, Performance Bonus Ltd, 2 St Mary St
          Chepstow, Monmouthshire, NP16 5BD<br />
          7.4 You have the right to have any inaccurate personal data about you
          rectified and, taking into account the purposes of the processing, to
          have any incomplete personal data about you completed.<br />
          7.5 In some circumstances you have the right to the erasure of your
          personal data without undue delay. Those circumstances include: the
          personal data are no longer necessary in relation to the purposes for
          which they were collected or otherwise processed; you withdraw consent
          to consent-based processing; you object to the processing under
          certain rules of applicable data protection law; the processing is for
          direct marketing purposes; and the personal data have been unlawfully
          processed. However, there are exclusions of the right to erasure. The
          general exclusions include where processing is necessary: for
          exercising the right of freedom of expression and information; for
          compliance with a legal obligation; or for the establishment, exercise
          or defence of legal claims.<br />
          7.6 In some circumstances you have the right to restrict the
          processing of your personal data. Those circumstances are: you contest
          the accuracy of the personal data; processing is unlawful but you
          oppose erasure; we no longer need the personal data for the purposes
          of our processing, but you require personal data for the
          establishment, exercise or defence of legal claims; and you have
          objected to processing, pending the verification of that objection.
          Where processing has been restricted on this basis, we may continue to
          store your personal data. However, we will only otherwise process it:
          with your consent; for the establishment, exercise or defence of legal
          claims; for the protection of the rights of another natural or legal
          person; or for reasons of important public interest.<br />
          7.7 You have the right to object to our processing of your personal
          data on grounds relating to your particular situation, but only to the
          extent that the legal basis for the processing is that the processing
          is necessary for: the performance of a task carried out in the public
          interest or in the exercise of any official authority vested in us; or
          the purposes of the legitimate interests pursued by us or by a third
          party. If you make such an objection, we will cease to process the
          personal information unless we can demonstrate compelling legitimate
          grounds for the processing which override your interests, rights and
          freedoms, or the processing is for the establishment, exercise or
          defence of legal claims.<br />
          7.8 You have the right to object to our processing of your personal
          data for direct marketing purposes (including profiling for direct
          marketing purposes). If you make such an objection, we will cease to
          process your personal data for this purpose.<br />
          7.9 You have the right to object to our processing of your personal
          data for scientific or historical research purposes or statistical
          purposes on grounds relating to your particular situation, unless the
          processing is necessary for the performance of a task carried out for
          reasons of public interest. <br />7.10 To the extent that the legal
          basis for our processing of your personal data is:<br />
          (a) consent; or<br />
          (b) that the processing is necessary for the performance of a contract
          to which you are party or in order to take steps at your request prior
          to entering into a contract, and such processing is carried out by
          automated means, you have the right to receive your personal data from
          us in a structured, commonly used and machine-readable format.
          However, this right does not apply where it would adversely affect the
          rights and freedoms of others.<br />
          7.11 If you consider that our processing of your personal information
          infringes data protection laws, you have a legal right to lodge a
          complaint with a supervisory authority responsible for data
          protection. You may do so in the EU member state of your habitual
          residence, your place of work or the place of the alleged
          infringement.<br />
          7.12 To the extent that the legal basis for our processing of your
          personal information is consent, you have the right to withdraw that
          consent at any time. Withdrawal will not affect the lawfulness of
          processing before the withdrawal.<br />
          7.13 You may exercise any of your rights in relation to your personal
          data by written notice to us.
          <br /><br /><b>8. About cookies</b><br />
          8.1 A cookie is a file containing an identifier (a string of letters
          and numbers) that is sent by a web server to a web browser and is
          stored by the browser. The identifier is then sent back to the server
          each time the browser requests a page from the server. <br />
          8.2 Cookies may be either "persistent" cookies or "session" cookies: a
          persistent cookie will be stored by a web browser and will remain
          valid until its set expiry date, unless deleted by the user before the
          expiry date; a session cookie, on the other hand, will expire at the
          end of the user session, when the web browser is closed. <br />
          8.3 Cookies do not typically contain any information that personally
          identifies a user, but personal information that we store about you
          may be linked to the information stored in and obtained from cookies.
          <br /><br />
          <b>9. Cookies that we use</b><br />
          9.1 We use cookies for the following purposes:<br />
          (a) authentication - we use cookies [to identify you when you visit
          our website and as you navigate our website.<br />
          (b) status - we use cookies [to help us to determine if you are logged
          into our website.<br />
          (c) personalisation - we use cookies to store information about your
          preferences and to personalise the website for you.<br />
          (d) security - we use cookies [as an element of the security measures
          used to protect user accounts, including preventing fraudulent use of
          login credentials, and to protect our website and services
          generally.<br />
          (e) advertising - we use cookies to help us to display advertisements
          that will be relevant to you.<br />(f) analysis - we use cookies [to
          help us to analyse the use and performance of our website and
          services.<br />
          (g) cookie consent - we use cookies to store your preferences in
          relation to the use of cookies more generally.<br /><br />
          <b>10. Cookies used by our service providers</b><br />
          10.1 Our service providers use cookies and those cookies may be stored
          on your computer when you visit our website.<br />
          10.2 We use Google Analytics to analyse the use of our website. Google
          Analytics gathers information about website use by means of cookies.
          The information gathered relating to our website is used to create
          reports about the use of our website. Google's privacy policy is
          available at:
          <a href="https://www.google.com/policies/privacy/"
            >https://www.google.com/policies/privacy</a
          >.<br />
          10.3 We may publish Google AdSense interest-based advertisements on
          our website. These are tailored by Google to reflect your interests.
          To determine your interests, Google will track your behaviour on our
          website and on other websites across the web using cookies. You can
          view, delete or add interest categories associated with your browser
          by visiting: https://adssettings.google.com. You can also opt out of
          the AdSense partner network cookie using those settings or using the
          Network Advertising Initiative's multi-cookie opt-out mechanism at:
          http://optout.networkadvertising.org. However, these opt-out
          mechanisms themselves use cookies, and if you clear the cookies from
          your browser your opt-out will not be maintained. To ensure that an
          opt-out is maintained in respect of a particular browser, you may wish
          to consider using the Google browser plug-ins available at:
          <a href="https://support.google.com/ads/answer/7395996"
            >https://support.google.com/ads/answer/7395996</a
          >.<br /><br />
          <b>11. Managing cookies</b><br />
          11.1 Most browsers allow you to refuse to accept cookies and to delete
          cookies. The methods for doing so vary from browser to browser, and
          from version to version. You can however obtain up-to-date information
          about blocking and deleting cookies via these web pages:<br />
          (a)
          <a href="https://support.google.com/chrome/answer/95647?hl=en"
            >https://support.google.com/chrome/answer/95647?hl=en</a
          >
          (Chrome);<br />
          (b)
          <a
            href="https://support.mozilla.org/en-US/kb/enable-and-disable-cookies-website-preferences"
            >https://support.mozilla.org/en-US/kb/enable-and-disable-cookies-website-preferences</a
          >
          (Firefox);<br />
          (c)
          <a href="http://www.opera.com/help/tutorials/security/cookies/"
            >http://www.opera.com/help/tutorials/security/cookies</a
          >
          (Opera);<br />
          (d)
          <a
            href="https://support.microsoft.com/en-gb/help/17442/windows-internet-explorer-delete-manage-cookies"
            >https://support.microsoft.com/en-gb/help/17442/windows-internet-explorer-delete-manage-cookies</a
          >
          (Internet Explorer);<br />
          (e)
          <a href="https://support.apple.com/kb/PH21411"
            >https://support.apple.com/kb/PH21411</a
          >(Safari); and<br />
          (f)
          <a
            href="https://privacy.microsoft.com/en-us/windows-10-microsoft-edge-and-privacy"
            >https://privacy.microsoft.com/en-us/windows-10-microsoft-edge-and-privacy </a
          >(Edge).<br />
          11.2 Blocking all cookies will have a negative impact upon the
          usability of many websites.<br />
          11.3 If you block cookies, you will not be able to use all the
          features on our website.<br /><br />
          <b>12. Our details</b><br />
          12.1 This website is owned and operated by Performance Bonus Ltd .<br />
          12.2 We are registered in England and Wales under registration number
          4326332 , and our registered office is at 2 St Mary Street, Chepstow,
          Monmouthshire NP16 5EU.<br />
          12.3 Our principal place of business is at 2 St Mary Street, Chepstow,
          Monmouthshire NP16 5EU<br />
          12.4 You can contact us:<br />
          (a) by post, to the postal address given above.<br />
          (b) using our website contact form<br />
          (c) by telephone, on the contact number published on our website from
          time to time<br />
          <br /><b>13. Data protection officer</b><br />
          13.1 Our data protection officer's contact details are: Data
          Protection Officer, Performance Bonus Ltd, 2 St Mary Street, Chepstow,
          Monmouthshire NP16 5EU.<br />
        </div>
        <!-- With CMS -->
        <div v-if="isCmsUsed === true" v-html="leftContent"></div>

        <div class="spacer-60"></div>
      </div>

      <div class="col-md-4 promos">
        <Promotions />
      </div>
      <div class="col-md-4 promos promos2">
        <Promotions />
      </div>
    </div>
    <Cards />
    <footer>
      <div class="row">
        <div class="col-md-12">
          <p>
            This website hosted at URL Bonusme.uk is provided by Performance
            Bonus Ltd a company registered in England and Wales (registration
            number 4326332) Registered Office: 2 St Mary Street, Chepstow,
            Monmouthshire, NP16 5EU. The Card and electronic money (‘e-money’)
            loaded on it are issued by Payment Card Solutions (UK) Limited
            trading as B4B Payments, a company registered in England and Wales
            (registration number 05941947) and registered office at 21-24
            Millbank, London, England, SW1P 4QP. Payment Card Solutions (UK)
            Limited is authorised and regulated in the UK by the Financial
            Conduct Authority (Firm Reference Number: 930619) for the issuing of
            e-money. Mastercard is a registered trademark, and the circles
            design is a trademark of Mastercard International Incorporated.
          </p>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import Cards from "./Cards.vue";
import Promotions from "./Promotions.vue";
export default {
  components: {
    Cards,
    Promotions
  },
  created() {
    this.leftContent =
      this.isCmsUsed === true &&
      this.cmsPage != undefined &&
      this.cmsPage.leftContent != null
        ? this.cmsPage.leftContent
        : "";
  },
  computed: {
    isCmsUsed: {
      get() {
        return this.$store.state.cms.isCmsUsed;
      }
    },
    cmsPage: {
      get() {
        return this.$store.state.cms.cmsPage;
      }
    }
  }
};
</script>
